// extracted by mini-css-extract-plugin
module.exports = {"negative":"styles_negative__VhTT0","positive":"styles_positive__rI20P"};